import * as React from "react";
import { useAboutContextProvider } from "../../../Core/AboutContextProvider";
import { DatePickerNoForm } from "../../../forms/informedv2/DatePicker";
import { useTestingAssistContextProvider } from "../../../TestingAssist/TestingAssistContextProvider";

export const DiaryTestingAssist = () => {
    const { about } = useAboutContextProvider();
    const { complianceDate, setComplianceDate, visitStartDate, setVisitStartDate } = useTestingAssistContextProvider();

    const onDiaryConfigurationVisitStartDateChange = (value) => {
        setVisitStartDate(value);
    }

    const onDiaryConfigurationDateChange = (value) => {
        setComplianceDate(value);
    }

    if (!about.TestingAssistEnabled)
        return null;

    return (
        <div className="row">
            <div className="col-md-12">
                <div className="panel panel-info">
                    <div className="panel-body">
                        <h3 className="text-primary">Testing Configuration Assist</h3>
                        <p className="text-muted">Set fields which will overwrite the diary configuration file</p>
                        <div className="col-md-6 form-group">
                            <label htmlFor="visitStart">Custom Visit Start Date</label>
                            <p className="text-muted">Set a custom visit start date</p>
                            <DatePickerNoForm id="visitStart" onChange={onDiaryConfigurationVisitStartDateChange} value={visitStartDate} className='form-control' placeholder="" />
                        </div>
                        <div className="col-md-6 form-group">
                            <label htmlFor="complianceDate">Custom Compliance Date</label>
                            <p className="text-muted">Set a custom compliance date</p>
                            <DatePickerNoForm id="complianceDate" onChange={onDiaryConfigurationDateChange} value={complianceDate} className='form-control' placeholder="" includeTime />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
} 
